var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplit = function SvgSplit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M10 2.292v15.416M6.875 3.958H4.792a2.5 2.5 0 0 0-2.5 2.5v7.084a2.5 2.5 0 0 0 2.5 2.5h2.083m6.25 0h2.083a2.5 2.5 0 0 0 2.5-2.5V6.458a2.5 2.5 0 0 0-2.5-2.5h-2.083"
  })));
};
export default SvgSplit;